import React from "react"

export default function CircleDotSpinner() {

    return (
        <div className="spinner spinner-11">
            <div className="ms-circle1 ms-circle" />
            <div className="ms-circle2 ms-circle" />
            <div className="ms-circle3 ms-circle" />
            <div className="ms-circle4 ms-circle" />
            <div className="ms-circle5 ms-circle" />
            <div className="ms-circle6 ms-circle" />
            <div className="ms-circle7 ms-circle" />
            <div className="ms-circle8 ms-circle" />
            <div className="ms-circle9 ms-circle" />
            <div className="ms-circle10 ms-circle" />
            <div className="ms-circle11 ms-circle" />
            <div className="ms-circle12 ms-circle" />
        </div>
    )
}